import { render, staticRenderFns } from "./ShiftCustomPlan.vue?vue&type=template&id=480966f7&"
import script from "./ShiftCustomPlan.vue?vue&type=script&lang=ts&"
export * from "./ShiftCustomPlan.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftCustomPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports